import { createContext } from 'react'
import { EditPanelInternalAction } from '../types/action'

export type EditPanelInternalActionContextProps = {
    performInternalAction: <T>(action: EditPanelInternalAction, value: T) => Promise<void>
}

export const EditPanelInternalActionContext = createContext({} as EditPanelInternalActionContextProps)
